class AlertService {
	getPrimaryMarkup(message) {
		return `<div class="alert alert-primary alert-dismissible fade show" role="alert">		
			<div>${message}</div>
			<button type="button" class="close" data-dismiss="alert" aria-label="Close">
				<span aria-hidden="true">&times;</span>
			</button>
		</div>
		`;
	}

	getErrorMarkup(message) {
		return `<div class="alert alert-danger alert-dismissible fade show" role="alert">		
			<div>${message}</div>
			<button type="button" class="close" data-dismiss="alert" aria-label="Close">
				<span aria-hidden="true">&times;</span>
			</button>
		</div>
		`;
	}
}

export let alertService = new AlertService();
